import { Modal } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '../../hooks/use_router';
import {
  CORE_PURCHASE_URL,
  CORE_TRIAL_PURCHASE_URL,
  PRO_PURCHASE_URL,
  PRO_TRIAL_PURCHASE_URL,
} from '../../lib/stripe';
import {
  getFormToDisplay,
  getForwardRoute,
  isOpen,
  SignupLoginModalActions,
  SignupLoginModalOpenPayload,
} from '../../redux/signup_login_modal';
import { SignupLogin } from '../signup_login/signup_login';
import styles from './signup_login_modal.less';

export const PRO_SIGNUP_LOGIN_MODAL_OPEN_PARAMS = {
  forwardRoute: PRO_PURCHASE_URL,
  heading: 'Create an Account & Upgrade to Omnia PRO',
  headingBlurb:
    'With a PRO account you’ll have access to map layers, 10% cashback, and FREE shipping.',
} as Partial<SignupLoginModalOpenPayload>;

export const PRO_TRIAL_SIGNUP_LOGIN_MODAL_OPEN_PARAMS = {
  ...PRO_SIGNUP_LOGIN_MODAL_OPEN_PARAMS,
  forwardRoute: PRO_TRIAL_PURCHASE_URL,
} as Partial<SignupLoginModalOpenPayload>;

export const CORE_SIGNUP_LOGIN_MODAL_OPEN_PARAMS = {
  forwardRoute: CORE_PURCHASE_URL,
  heading: 'Create an Account & Upgrade to Omnia Core',
  headingBlurb:
    'With a Core account you will have access to map layers, 5% cashback, and FREE shipping.',
} as Partial<SignupLoginModalOpenPayload>;

export const CORE_TRIAL_SIGNUP_LOGIN_MODAL_OPEN_PARAMS = {
  ...CORE_SIGNUP_LOGIN_MODAL_OPEN_PARAMS,
  forwardRoute: CORE_TRIAL_PURCHASE_URL,
} as Partial<SignupLoginModalOpenPayload>;

export const SignupLoginModal = React.memo(() => {
  const dispatch = useDispatch();
  const open = useSelector(isOpen);
  const forwardRoute = useSelector(getForwardRoute);
  const initialFormToDisplay = useSelector(getFormToDisplay);
  const { pathname } = useRouter();

  useEffect(() => {
    return () => {
      dispatch(SignupLoginModalActions.SIGNUP_LOGIN_MODAL_CLOSE());
    };
  }, []);

  return (
    <>
      <Modal
        width={480}
        open={open}
        onCancel={() => {
          dispatch(SignupLoginModalActions.SIGNUP_LOGIN_MODAL_CLOSE());
        }}
        footer={null}
        title={null}
        wrapClassName={styles.modal}
        centered
      >
        <SignupLogin
          forwardRoute={forwardRoute}
          fromPath={pathname}
          defaultTab={initialFormToDisplay}
        />
      </Modal>
    </>
  );
});
